import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ProductGridCard from '../Products/ProductGridCard';
import Pagination from '../common/Pagination';
import productStyles from '../../styles/Products.module.scss';
import styles from '../../styles/HomeCatalog.module.scss';

const COLS = 4;
const ROWS = 8;
const PAGE_SIZE = COLS * ROWS;

const HomeCatalog = () => {
  const products = useSelector((state) => state.products.list);
  const [page, setPage] = useState(1);
  const sectionRef = useRef(null);

  const totalPages = Math.max(1, Math.ceil(products.length / PAGE_SIZE));

  const pageItems = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return products.slice(start, start + PAGE_SIZE);
  }, [products, page]);

  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  const handlePageChange = (nextPage) => {
    const safePage = Math.min(Math.max(1, nextPage), totalPages);
    setPage(safePage);
    sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (!products.length) {
    return null;
  }

  return (
    <section
      ref={sectionRef}
      className={`${productStyles.products} productsFullBleed ${styles.catalog}`}
    >
      <h2>Каталог товарів</h2>
      <p className={styles.subtitle}>
        Оберіть товар для перегляду та покупки · {products.length} позицій
      </p>

      <div className={styles.grid}>
        {pageItems.map((product) => (
          <ProductGridCard key={product.id} product={product} />
        ))}
      </div>

      <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </section>
  );
};

export default HomeCatalog;
